import { ListTable as ListTableBase } from './ListTable';
import { ListTableCard } from './ListTable.Card';
import { ListTableCell } from './ListTable.Cell/ListTable.Cell';
import { ListTableHeader } from './ListTable.Header/ListTable.Header';
import { ListTableHeaderCell } from './ListTable.HeaderCell/ListTable.HeaderCell';
import { ListTableRow } from './ListTable.Row/ListTable.Row';

export const ListTable = Object.assign(ListTableBase, {
  Card: ListTableCard,
  Cell: ListTableCell,
  Row: ListTableRow,
  Header: ListTableHeader,
  HeaderCell: ListTableHeaderCell
});
